import { createFileRoute, redirect } from "@tanstack/react-router";

// /office/smart-actions has no landing page of its own: the board is the first screen.
export const Route = createFileRoute("/office/smart-actions/")({
  beforeLoad: async () => {
    throw redirect({ to: "/office/smart-actions/board" });
  },
});
